import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import "../Forms/css/register.css";

const token = localStorage.getItem('authToken');

class AddMerchant extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      storeName: '',
      storeDescription: '',
      ownerName: '',
      contactEmail: '',
      contactPhone: '',
      storeAddress: '',
      websiteURL: '',
      storeLogo: '',
      storeBannerImage: '',
      category: '',
      paymentMethods: [],
      shippingMethods: '',
      storePolicies: '',
      businessRegistrationNumber: '',
      socialMediaLinks: '',
      taxIdentificationNumber: '',
      operatingHours: '',
      additionalNotes: '',
      showPassword: false,
      showConfirmPassword: false,
      submissionStatus: null,
    };
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleFileChange = (e) => {
    const { name, files } = e.target;
    this.setState({ [name]: files[0] });
  };

  handleSelectChange = (name, values) => {
    this.setState({ [name]: values.map(v => v.value) });
  };

  togglePasswordVisibility = (field) => {
    this.setState((prevState) => ({
      [field]: !prevState[field]
    }));
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    Object.keys(this.state).forEach(key => {
      if (Array.isArray(this.state[key])) {
        formData.append(key, this.state[key].join(','));
      } else {
        formData.append(key, this.state[key]);
      }
    });

    try {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`
        }
      };

      const response = await axios.post("https://brand.aasmo.in/api/superadmin/addMerchant", formData, config);
      console.log('Response:', response);

      if (response && response.status === 201) {
        this.setState({ submissionStatus: 'success' });
        console.log('Form submitted successfully');
        setTimeout(() => {
          window.location.href = "/listMerchants";
        }, 2000);
      } else {
        console.log('Unexpected response:', response);
      }

    } catch (error) {
      console.error('Error submitting form:', error);
      if (error.response) {
        const { status, data } = error.response;
        if (status === 400) {
          console.error('Bad request error:', data);
        } else if (status === 401) {
          console.error('Unauthorized error, please log in again.');
        } else {
          console.error('Error response:', error.response);
        }
      } else {
        console.error('Network or other error:', error);
      }
    }
  };

  render() {
    const { submissionStatus } = this.state;
    return (
      <div className="col-md-12">
        <form onSubmit={this.handleSubmit}>
          <div className="card">
            <div className="header">
              <h2>Add Merchant</h2>
            </div>
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Store Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="storeName"
                      value={this.state.storeName}
                      onChange={this.handleChange}
                      placeholder="Store Name"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Owner Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="ownerName"
                      value={this.state.ownerName}
                      onChange={this.handleChange}
                      placeholder="Owner Name"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Contact Email</label>
                    <input
                      type="email"
                      className="form-control"
                      name="contactEmail"
                      value={this.state.contactEmail}
                      onChange={this.handleChange}
                      placeholder="Ex: abc@example.com"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Contact Phone</label>
                    <input
                      type="text"
                      className="form-control"
                      name="contactPhone"
                      value={this.state.contactPhone}
                      onChange={this.handleChange}
                      placeholder="Ex: 017********"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Store Address</label>
                    <input
                      type="text"
                      className="form-control"
                      name="storeAddress"
                      value={this.state.storeAddress}
                      onChange={this.handleChange}
                      placeholder="Store Address"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Website URL</label>
                    <input
                      type="url"
                      className="form-control"
                      name="websiteURL"
                      value={this.state.websiteURL}
                      onChange={this.handleChange}
                      placeholder="Website URL"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Store Logo</label>
                    <input
                      type="file"
                      className="form-control"
                      name="storeLogo"
                      onChange={this.handleFileChange}
                    />
                    {this.state.storeLogo && (
                      <img
                        src={URL.createObjectURL(this.state.storeLogo)}
                        alt="Store Logo"
                        className="img-thumbnail mt-2"
                      />
                    )}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Store Banner Image</label>
                    <input
                      type="file"
                      className="form-control"
                      name="storeBannerImage"
                      onChange={this.handleFileChange}
                    />
                    {this.state.storeBannerImage && (
                      <img
                        src={URL.createObjectURL(this.state.storeBannerImage)}
                        alt="Store Banner"
                        className="img-thumbnail mt-2"
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-primary">Submit</button>
                {submissionStatus === 'success' && <p className="text-success">Merchant added successfully!</p>}
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {})(AddMerchant);
